import AllowNotificationsCard from './AllowNotificationsCard'

export default AllowNotificationsCard
